import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PRICE_LIST = {
  'Accounts': 3,
  'Arts and Humanities': 2,
  'Economics': 2,
  'Engineering': 4,
  'Computer Science': 4,
  'Law': 3,
  'Management': 2,
  'Nursing': 3,
  'Business': 3 // Assuming 'Business' same as 'Accounts' unless specified
};

const OrderDetails = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    assignmentType: '',
    subject: '',
    deadline: '',
    firstDraft: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add price calculation here if needed
    if (formData.assignmentType && formData.subject && formData.deadline) {
      // You can pass the price per word if needed: {...formData, pricePerWord: PRICE_LIST[formData.subject]}
      navigate('/checkout/task-details', { state: formData });
    } else {
      alert('Please fill all required fields.');
    }
  };

  return (
    <div className="min-h-screen bg-[#02042b] py-16 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-white mb-2">
          Provide your order details
        </h1>
        <p className="text-center text-lg text-gray-300 mb-8">
          (Share the key details so our experts can craft the perfect assignment for you)
        </p>

        <div className="flex flex-col lg:flex-row gap-8 relative">
          <div className="flex-1 bg-white rounded-2xl p-6 shadow-lg">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-800 font-semibold mb-2">Assignment Type *</label>
                <select
                  name="assignmentType"
                  value={formData.assignmentType}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none"
                  required
                >
                  <option value="" disabled>Select *</option>
                  <option value="Dissertation / Theses">Dissertation / Thesis</option>
                  <option value="Essay">Essay</option>
                  <option value="Case Study">Case Study</option>
                  <option value="Report">Report</option>
                  <option value="Assignment">Assignment</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-800 font-semibold mb-2">Subject *</label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none"
                  required
                >
                  <option value="" disabled>Select *</option>
                  <option value="Arts and Humanities">Arts & Humanities</option>
                  <option value="Business">Business</option>
                  <option value="Engineering">Engineering</option>
                  <option value="Computer Science">Computer Science</option>
                  <option value="Accounts">Accounts</option>
                  <option value="Nursing">Nursing</option>
                  <option value="Law">Law</option>
                  <option value="Management">Management</option>
                  <option value="Economics">Economics</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-800 font-semibold mb-2">Due Date *</label>
                <input
                  type="date"
                  name="deadline"
                  value={formData.deadline}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none"
                  required
                />
              </div>
              <div className="border border-gray-300 rounded-xl p-4 flex justify-between items-center">
                <div>
                  <h3 className="font-semibold text-gray-800">Need a First Draft Sooner?</h3>
                  <p className="text-gray-600">Receive a draft before the final deadline to track progress and make revisions.</p>
                  <label className="inline-flex items-center mt-2">
                    <input
                      type="checkbox"
                      className="form-checkbox text-orange-500"
                      name="firstDraft"
                      checked={formData.firstDraft}
                      onChange={handleChange}
                    />
                    <span className="ml-2 font-semibold text-gray-800">Add for just +5% extra</span>
                  </label>
                </div>
                <img src="https://png.pngtree.com/png-clipart/20190902/original/pngtree-hand-drawn-cartoon-clock-png-element-png-image_4388137.jpg" alt="Clock" className="h-16 w-16" />
              </div>
              <div className="text-right">
                <button
                  type="submit"
                  className="px-6 py-2 bg-[#373057] text-white rounded-lg shadow hover:bg-[#4a4882] transition"
                >
                  Next
                </button>
              </div>
            </form>
          </div>

          <div className="flex-1">
            <div className="flex justify-end">
              <button className="px-6 py-2 rounded-full bg-[#1f2937] text-white font-medium">
                Order Information
              </button>
            </div>
            <div className="mt-8 bg-white rounded-3xl p-6 shadow-xl">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">Provide your order details</h2>
              <p className="text-gray-600 mb-1">
                <span className="font-semibold">Assignment Type:</span> {formData.assignmentType || '—'}
              </p>
              <p className="text-gray-600 mb-1">
                <span className="font-semibold">Subject:</span> {formData.subject || '—'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Deadline:</span> {formData.deadline || '—'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">First Draft Required:</span> {formData.firstDraft ? 'Yes' : 'No'}
              </p>
              <div className="mt-4 h-10 w-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                1
              </div>
              {formData.subject && (
                <div className="mt-4 text-gray-800">
                  <span className="font-semibold">Price Per Word:</span> {PRICE_LIST[formData.subject] ? `${PRICE_LIST[formData.subject]} INR` : '—'}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
